import { I18N } from "./I18N"

export class OrderHelper {

	static renderLabel = order => {
		return order.getCart().items.map(i => i.product.productName).join(', ')
	}

	static getReceiptHtml = (order, store, width, fontHeight) => `
		<div>
			<style type="text/css">
				${OrderHelper.getCss(width, fontHeight)}
			</style>
			${OrderHelper.getHtml(order, store)}
		</div>
	`

	static getCss = (width, fontHeight) => `
		.receipt,
		.receipt * {
			font-size: ${fontHeight};
		}
		.receipt {
			font-family: system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif;
			width: ${width ? width : '58mm'};
			margin: 0;
			color: #000;
		}
		.receipt img {
			width: 100%;
		}
		.receipt .bigger {
			font-size: 1.2em;
		}
		.receipt table {
			width: 100%;
		}
		.receipt table.receipt-items-table tr td:nth-child(2) {
			text-align: right;
		}
	`

	static getHtml = (order, store) => `
		<div id="receipt-${order.getIdString()}" class="receipt">
			<div><img src="${store ? store.receiptImageUrl : ''}"></div>
			<table>
				<tr><td>&nbsp;</td></tr>
				<tr><td>Bestellung:</td><td><strong class="bigger">${order.getInvoiceNumber() ? order.getInvoiceNumber() : order.getIdString()}</strong></td></tr>
				<tr><td>Name:</td><td>${order.getCustomerNameString()}</td></tr>
				<tr><td>Tel.:</td><td>${order.getCustomerPhone()}</td></tr>
				<tr><td>Bestelldatum:</td><td>${order.getReceiveDateTimeString(true)}</td></tr>
				<tr><td id="deliveryDateType">Lieferzeitpunkt:</td><td id="receiptDliveryDate">${order.getDeliveryDateTime(false)}</td></tr>
				<tr>
					<td>${order.isDelivery() ? 'Lieferadresse:' : '<strong>Abholung</strong>'}</td>
					<td>${order.isDelivery() ? order.getShortDeliveryAddressString() : ''}</td>
				</tr>
				${order.isDelivery() && order.getDoorbell() ? `<tr><td>Name am Klingelschild:</td><td>${order.getDoorbell()}</td></tr>` : ''}
				<tr><td>&nbsp;</td></tr>
			</table>
			${OrderHelper._getDetailsHtml(order)}
			<div><strong>Zahlungsweise: ${order.getPaymentMethod()}</strong></div>
			<div id="bb-spacer">__</div>
		</div>
	`

	static _getDetailsHtml = order => `
		<table class="receipt-items-table">
			${order.getCart().items.map(
				i => `<tr><td><strong>${i.qty} x ${i.product.productName}${i.variant ? ` - ${i.variant.name}` : ''}</strong></td><td><strong>${OrderHelper._formatPrice((i.variant ? (Number(i.variant.net) + Number(i.variant.tax)) : (Number(i.product.net) + Number(i.product.tax))) * i.qty)}</strong></td></tr>
				${OrderHelper._getExtrasListHtml(i.extraCategories, i.qty)}
				${i.remarks ? `<tr><td colspan="2">&nbsp;&nbsp;&nbsp;&nbsp;Bem.:&nbsp;<em>${i.remarks}</em></td></tr>\n` : ''}`
			)
			.join('')}
			${order.getRemarks() ? `<tr><td colspan="2">Bem.:&nbsp;<em>${order.getRemarks()}</em></td></tr>` : ''}
				<tr><td>&nbsp;</td></tr>
				${order.getDiscounts().map(d => `<tr><td>${I18N.translate(d.type)}:</td><td>${OrderHelper._formatPrice(-Number(d.netDiscount) - Number(d.tax))}</td></tr>`).join('')}
				${OrderHelper._getFeesHtml(order.getFees())}
				<tr><td><strong>Summe:</strong></td><td><strong>${order.getPrice()}</strong></td></tr>
				<tr><td>Enthaltene MwSt.:</td><td>${order.getTax()}</td></tr>
				<tr><td>&nbsp;</td></tr>
		</table>
	`

	// Bei gemischten Bestellungen (7%/19%) kann eine Gebühr (Liefergebühr, Mindestbestellwert-
	// Zuschlag) als zwei Einträge desselben Typs zurückkommen, anteilig nach Steuersatz
	// gesplittet (order-fees FeeCalculator). Ohne Kennzeichnung sähen zwei gleichlautende
	// Zeilen wie ein Fehler aus, daher wird der Steuersatz ergänzt, sobald ein Typ mehrfach
	// vorkommt.
	static _getFeesHtml = fees => {
		const countsByType = fees.reduce((counts, f) => {
			counts[f.type] = (counts[f.type] || 0) + 1
			return counts
		}, {})
		return fees.map(f => {
			const label = countsByType[f.type] > 1 && f.taxRatePercent != null
				? `${I18N.translate(f.type)} (${f.taxRatePercent}%)`
				: I18N.translate(f.type)
			return `<tr><td>${label}:</td><td>${OrderHelper._formatPrice(Number(f.netFee) + Number(f.tax))}</td></tr>`
		}).join('')
	}

	static _getExtrasListHtml = (extraCategories, qty) =>
		extraCategories 
		? extraCategories.map(
			c => c.extraOptions.map(
				e => `<tr><td>&nbsp;&nbsp;&nbsp;&nbsp;&#x26AC;&nbsp;${e.extraOptionName}</td><td>${OrderHelper._formatPrice((Number(e.net) + Number(e.tax)) * qty)}</td></tr>\n`
			).join('')
		).join('')
		: ''
	
	static _formatPrice = number => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number).replace(' ', '')

	static roundCurrency = number => Math.round(number * 100)/100

}